import { Directive, effect, inject, signal, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Directive({
  selector: '[coreAuthHasNotGroup]',
})
export class HasNotGroupDirective {
  private _authService = inject(AuthService);
  private _templateRef = inject(TemplateRef<any>);
  private _viewContainer = inject(ViewContainerRef);
  private _show = signal(false);

  @Input({ alias: 'coreAuthHasNotGroup' })
  set groupCheck(group: string | string[]) {
    this._show.set(!this._authService.isInGroup(group));
  }

  constructor() {
    effect(() => {
      this._viewContainer.clear();
      if (this._show()) {
        this._viewContainer.createEmbeddedView(this._templateRef);
      }
    });
  }
}
